// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_afa5b037","lastItem":"_a730be7b","item":"_20e77631"};